import React from 'react';
const testimonials = [{
  stars: 5,
  text: "Tuve cándida 5 veces en un año. El ginecólogo me dijo que era 'propensa'. Después del protocolo de 72 horas, el alivio fue en menos de un día. Llevo 4 meses sin una sola recaída.",
  name: 'Valentina, 29',
  city: 'CABA'
}, {
  stars: 5,
  text: 'Lo mío era intestinal. Me hinchaba como si estuviera embarazada. Nadie me lo había relacionado con la cándida. Perdí 3 kilos de inflamación en 10 días.',
  name: 'Romina, 38',
  city: 'Rosario'
}, {
  stars: 5,
  text: 'Mi relación de pareja estaba sufriendo. El dolor me hacía evitar el contacto. Hoy eso es historia. Lo que más me sorprendió: lo simple que fue la lista de compras.',
  name: 'Lucía, 33',
  city: 'Córdoba'
}, {
  stars: 5,
  text: 'Después de 3 rondas de antibióticos, mi flora estaba destruida. La cándida volvía cada mes como un reloj. Con la Fase 2 del protocolo reconstruí todo en semanas. Hoy me siento otra persona.',
  name: 'Carolina, 27',
  city: 'Mendoza'
}, {
  stars: 5,
  text: 'Los antojos de dulce me controlaban la vida. No podía pasar una tarde sin comer algo azucarado. A los 10 días del protocolo, desaparecieron. Siento que recuperé el control de mi cuerpo.',
  name: 'Agustina, 41',
  city: 'La Plata'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-brand-gray px-6 py-16" data-id="element-281">
      <div className="max-w-4xl mx-auto" data-id="element-282">
        <h2 className="text-[28px] font-bold text-brand-text text-center mb-2 leading-tight" data-id="element-283">
          ELLAS YA ROMPIERON EL CICLO
        </h2>
        <p className="text-brand-muted text-center text-[16px] mb-12" data-id="element-284">
          Lo que cambia cuando entendés la causa real
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-285">
          {testimonials.map((t, i) => <div key={i} className="bg-white rounded-[16px] p-6 shadow-[0_4px_24px_rgba(0,0,0,0.08)] flex flex-col" data-id="element-286">
              <div className="flex gap-1 mb-4" data-id="element-287">
                {Array.from({
              length: t.stars
            }).map((_, s) => <span key={s} className="text-yellow-400 text-lg" data-id="element-288">
                    ⭐
                  </span>)}
              </div>
              <p className="text-[15px] text-brand-text italic leading-relaxed mb-4 flex-1" data-id="element-289">
                "{t.text}"
              </p>
              <p className="text-brand-text text-[14px]" data-id="element-290">
                <strong className="font-bold" data-id="element-291">{t.name}</strong>{' '}
                <span className="text-brand-muted" data-id="element-292">· {t.city}</span>
              </p>
            </div>)}
        </div>

        <p className="text-brand-muted text-[12px] text-center italic" data-id="element-293">
          ⚠️ Los nombres fueron modificados para proteger la privacidad.
        </p>
      </div>
    </section>;
}